import { useViewModel } from '@/lib/viewModels'
import { RNumberViewModel } from './RNumberViewModel'
import styled from 'styled-components'
import { observer } from 'mobx-react-lite'
import { FormWrapper, Wrapper } from '@/modules/landings/protection/components/TrackingNumber'
import { TrackingResult } from '@/modules/landings/protection/components/TrackingResult'
import React from 'react'
import { TrackingNumberForm } from '@/modules/landings/protection/components/TrackingNumberForm'
import { themeGet } from '@styled-system/theme-get'
import { useApiService } from '@/lib/apiService'

export const TrackingNumberFormViewWrapper = styled.div`
	body:has(&) {
		.ant-input-affix-wrapper-focused {
			border-color: ${themeGet('primary.0', '#002FA8')};
		}
	}
`

export interface RNumberViewProps {}

const RNumberViewWrapper = styled.div``
export const RNumberView: React.FC<RNumberViewProps> = observer((props) => {
	const apiService = useApiService()
	const { status, actions } = useViewModel({ apiService }, RNumberViewModel)
	console.log(status.resultStatus)
	return (
		<RNumberViewWrapper>
			<Wrapper>
				<p className={'title'}>
					R인증 번호를 조회하여
					<br />
					정당한 저작권 이용 여부를 확인하세요.
				</p>
				<FormWrapper>
					<TrackingNumberFormViewWrapper>
						<TrackingNumberForm
							title={'R인증 번호 조회'}
							name={'TrackingNumberForm'}
							initialStatus={status.initialStatus}
							initialValues={status.initialValues}
							onSubmit={actions.onSubmit}
						/>
					</TrackingNumberFormViewWrapper>
				</FormWrapper>
			</Wrapper>
			<TrackingResult data={status.RNumberResult} />
		</RNumberViewWrapper>
	)
})
